/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ITableSorts {
  tableSortValues: {};
  rawTableData: any;
}

const initialState: ITableSorts = {
  tableSortValues: {
    field: '',
    order: 'ASC'
  },
  rawTableData: null
};

export const tableSortValuesSlice = createSlice({
  name: 'tableSortValues',
  initialState,
  reducers: {
    setTableSortValues: (state: ITableSorts, action: PayloadAction<{}>) => {
      const { payload } = action;
      state.tableSortValues = payload;
    },
    setRawTableData: (state: ITableSorts, action: PayloadAction<any>) => {
      const { payload } = action;
      state.rawTableData = payload;
    }
  }
});

const { actions, reducer } = tableSortValuesSlice;
export const { setTableSortValues, setRawTableData } = actions;
export default reducer;
